export default __webpack_public_path__ + "static/media/sb.8062ca05.svg";